export default "__VITE_ASSET__DYACAnoW__"